import React from 'react'
import Marketing from './Marketing'

const MarketingContainer = () => {
  return (<div className="container proxima-nova">
    <Marketing />
  </div>)
}

export default MarketingContainer
